<div class="card scrollbar">
    <div class="card-content">
<div class="card-header d-flex justify-content-between" translate>
      lblContactList
    <div class="font16 fontbold">
        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
        {{totalCount}}
        &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
    </div>
</div>
<div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
    <table class="tablest1">
        <thead>
            <tr>
                <th style="width:55px" scope="col" translate>#</th>
                <th scope="col" sortable="customerType" translate>
                    lblCustomerNo</th>
                <th scope="col" sortable="customerName" translate>
                    lblCustomerName</th>
                <th scope="col" sortable="pincode" translate>
                    lblAddress</th>
               
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="contactList?.length>0; else load_NotFound_Template">
                <tr *ngFor="let item of contactList; let i=index">
                    <td>{{ item.rowNumber }}</td>
                    <td>
                        <ngb-highlight [result]="item.customerNo">
                        </ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight class="fs-14px semibold lh-18px d-block"
                            [result]="item.customerName">
                        </ngb-highlight>
                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px"
                            *ngIf="item.mobileNo">
                            <em _ngcontent-xdg-c220=""
                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                            <span class="fs-12px"
                                *ngIf="item.mobileCode">{{item.mobileCode}}-</span>
                            <ngb-highlight class="fs-12px" [result]="item.mobileNo">
                            </ngb-highlight>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="item.email">
                            <em _ngcontent-xdg-c220=""
                                class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                            <ngb-highlight class="fs-12px" [result]="item.email">
                            </ngb-highlight>
                        </div>
                    </td>
                    <td>
                        <ngb-highlight [result]="item.addressLine1">
                        </ngb-highlight>
                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px">
                            <ngb-highlight class="fs-12px mr-2" [result]="item.pincode">
                            </ngb-highlight>
                            <ngb-highlight class="fs-12px" [result]="item.city">
                            </ngb-highlight>
                        </div>
                        <div class="d-flex align-items-center">
                            <ngb-highlight class="fs-12px" [result]="item.country">
                            </ngb-highlight>
                        </div>
                    </td>
                   
                </tr>
            </ng-container>
            <ng-template #load_NotFound_Template>
                <tr>
                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>
</div>
</div>